import React, { ReactElement } from 'react';
import { IComponentLeftImageRightAccordionFields } from 'types/contentful';

import CTA from '../UI/Cta';
import Image from '../UI/Image';
import Accordion from '../UI/Accordion';

export default function ImageLeftAccordionRight({
  heading,
  cta,
  image,
  accordion,
}: IComponentLeftImageRightAccordionFields): ReactElement {
  return (
    <div className="flex flex-col lg:flex-row lg:px-16 lg:py-10">
      <div className="w-full lg:w-3/5">
        <Image image={image} query="w=672" classNames="object-cover mx-auto lg:mx-0" />
      </div>
      <div className="flex flex-col lg:w-2/5 p-4 lg:pl-12 lg:pt-8 lg:pb-0">
        <h2 className="font-heading  text-2xl lg:text-4xl">{heading}</h2>

        <div className="flex flex-col justify-between h-full mt-4">
          <Accordion {...accordion.fields} standAlone={false} />

          <div className="relative bottom-0 mt-2">
            {cta && <CTA {...cta.fields} classNames="" />}
          </div>
        </div>
      </div>
    </div>
  );
}
